var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"lang-btn","title":_vm.$t('Change Language')},on:{"click":_vm.changeLanguage}},[_c('img',{attrs:{"src":_vm.langPathImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }